/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Responsive_IndicatorInputs */

const en_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsive Indicator`)
};

const ar_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مؤشر التجاوب`)
};

const bn_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রেসপন্সিভ ইন্ডিকেটর`)
};

const de_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaktionsindikator`)
};

const es_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicador Responsivo`)
};

const fr_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicateur réactif`)
};

const pt_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicador responsivo`)
};

const zh_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应指标`)
};

const tr_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyarlı Gösterge`)
};

const ru_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адаптивный индикатор`)
};

const pl_dev_item_responsive_indicator = /** @type {(inputs: Dev_Item_Responsive_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wskaźnik reakcji`)
};

/**
* | output |
* | --- |
* | "Responsive Indicator" |
*
* @param {Dev_Item_Responsive_IndicatorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_responsive_indicator = /** @type {((inputs?: Dev_Item_Responsive_IndicatorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Responsive_IndicatorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_responsive_indicator(inputs)
	if (locale === "bn") return bn_dev_item_responsive_indicator(inputs)
	if (locale === "de") return de_dev_item_responsive_indicator(inputs)
	if (locale === "es") return es_dev_item_responsive_indicator(inputs)
	if (locale === "fr") return fr_dev_item_responsive_indicator(inputs)
	if (locale === "pt") return pt_dev_item_responsive_indicator(inputs)
	if (locale === "zh") return zh_dev_item_responsive_indicator(inputs)
	if (locale === "tr") return tr_dev_item_responsive_indicator(inputs)
	if (locale === "ru") return ru_dev_item_responsive_indicator(inputs)
	if (locale === "pl") return pl_dev_item_responsive_indicator(inputs)
	return en_dev_item_responsive_indicator(inputs)
});